import { useEffect, useMemo } from "react";
import { Outlet, useLocation, useNavigate, NavLink } from "react-router-dom";
import { Tabs } from "@/components";

const Settings = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/settings") {
      navigate("/settings/channel", { replace: true }); // Prevents unnecessary history entries
    }
  }, [location.pathname, navigate]);

  const tabs = useMemo(
    () => [
      { label: "Channel", link: "channel" },
      { label: "Courier Mgmt.", link: "courierMgmt" },
      { label: "Employee Login", link: "employeeLogin" },
      { label: "Rate Chart", link: "rate" },
      { label: "Pincode", link: "pincode" },
    ],
    []
  );

  return (
    <div className="w-full flex-1 flex flex-col pb-20 md:pb-4 relative max-w-[2000px]">
      <Tabs tabs={tabs} NavLink={NavLink} />
      <Outlet />
    </div>
  );
};

export default Settings;
